import { ref, watch, onMounted, onUnmounted } from 'vue'
import { readDomIdle, cancelFastDom } from 'gleam-shared/browser/fastDom'

export default function useHelpCenterFragmentTracker(postRef) {
  let rootHeaders = []
  const rootFragmentRef = ref(null)

  watch(postRef, toggle)
  onMounted(toggle)
  onUnmounted(pause)

  return rootFragmentRef

  function toggle() {
    if (postRef.value) {
      start()
    } else {
      pause()
    }
  }

  function start() {
    lazyQuery()
    window.addEventListener('scroll', lazyUpdate, { passive: true })
    window.addEventListener('resize', lazyUpdate, { passive: true })
  }

  function pause() {
    window.removeEventListener('scroll', lazyUpdate)
    window.removeEventListener('resize', lazyUpdate)
    cancelFastDom(execQuery)
    cancelFastDom(execUpdate)
  }

  function lazyQuery() {
    readDomIdle(execQuery)
  }

  function execQuery() {
    if (!postRef.value) {
      return
    }

    rootHeaders = postRef.value.components.filter(({ title_level }) => {
      return title_level === 1
    }).map(({ fragment }) => {
      return document.getElementById(fragment)
    })

    lazyUpdate()
  }

  function lazyUpdate() {
    readDomIdle(execUpdate)
  }

  function execUpdate() {
    if (rootHeaders.length === 0) {
      return
    }

    updateGivenFragment(rootHeaders, rootFragmentRef)
  }
}

function updateGivenFragment(givenHeaders, givenFragmentRef) {
  const buffer = 2 // allowing a small computing error in large posts
  const scrollerTop = parseFloat(window.getComputedStyle(document.documentElement).scrollPaddingTop)
  const scrollerBottom = window.innerHeight - window.innerHeight/8 // should be a bit above the edge

  console.assert(Number.isFinite(scrollerTop))

  for (const header of givenHeaders) {
    const headerRect = header.getBoundingClientRect()
    const headerTop = headerRect.top + headerRect.height/2 + buffer // considered visible when half of it is below the edge
    const headerBottom = headerRect.bottom

    if (headerTop > scrollerTop && headerBottom < scrollerBottom) {
      givenFragmentRef.value = header.id // visible top most header
      return
    }
  }

  for (const header of givenHeaders.toReversed()) {
    const headerRect = header.getBoundingClientRect()

    if (headerRect.top < scrollerTop) {
      givenFragmentRef.value = header.id // scrolled past top most header
      return
    }
  }

  givenFragmentRef.value = null
}
